import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// utils
import { capitalize } from '../../utils/text';

// Appt Components
import Box from '../../components/simple/box/Box';
import DataTable from '../../components/simple/dataTable/DataTable.js';
import Text from '../../components/simple/text/Text';

// Services
import FormService from '../../services/FormService';
import LocalStorageService from '../../services/LocalStorageService';
import ActionButton from '../../components/compound/actionButton/ActionButton.js';
import Anchor from '../../components/simple/anchor/Anchor.js';


const AIIncidentToolsResults = props => {
  const apiToken = LocalStorageService.get('apiToken');
  const activeOrg = LocalStorageService.get('activeOrg');
  const terms = LocalStorageService.get('terms')

  const [submissions, setSubmissions] = useState([]);
  const [responses, setResponses] = useState([]);

  const navigate = useNavigate();

  const deleteReport = async submissionId => {
    if (window.confirm('Are you sure you want to delete this?')) {
      await FormService.updateSubmission(apiToken, submissionId, {
        status: 'Archived',
      });
      window.location.reload(); // this is not ideal
    }
  };

  const [sort, setSort] = useState({
    property: 'reference',
    direction: 'desc'
  })

  const resultColumns = [
    {
      property: 'reference',
      header: <Text>Incident No</Text>,
      render: datum => (
        // <Text>{datum.id ? `besmart-${datum.reference}` : ''}</Text>
         <Anchor
          color='primary'
          onClick={() => {

            if (datum?.subtype === 'highlevel') {
              navigate(`/incident/high-level/${datum.userId}/edit/${datum.id}`);
            } else {
              navigate(`/incident/${datum.userId}/edit/${datum.id}`);
            }
            
          }}
          target="_self"
          plain
        ><Text>{datum.id ? `besmart-${datum.reference}` : ''}</Text></Anchor>
      ),
    },
    {
      property: 'firstName',
      header: (
        <Text>{capitalize(terms?.serviceUser || 'Service User')}</Text>
      ),
      render: datum => (
        <Anchor href={`/serviceuser/${datum.id}/profile`} color='primary'>
          <Text>{`${datum.firstname || ''} ${datum.lastname || ''}`}</Text>
        </Anchor>
      ),
    },
    {
      property: 'yearGroup',
      header: <Text>Year Group</Text>,
      render: datum => (
        <Anchor href={`/serviceusers/year/${datum.yearGroup}`} color='primary' label={`${datum.yearGroup || ''}`} />
      ),
    },
    {
      property: 'dateOfIncident',
      header: <Text>Date Of Incident</Text>,
      render: datum => (
        <Text>
          {moment(datum.dateOfIncident).format('DD/MM/YY') === 'Invalid date'
            ? 'No Date'
            : moment(datum.dateOfIncident).format('DD/MM/YY')}
        </Text>
      ),
    },
    {
      property: 'flag',
      header: <Text>Flag</Text>,
      render: datum => {
        const setColour = async color => {
          await FormService.updateSubmission(apiToken, datum.id, {
            flag: color,
          });

          let elements = Array.from(document.getElementsByClassName(`flag-${datum.id}`))
          for (let i = 0; i < elements.length; i++) {
            if (elements[i].id === `flag-${datum.id}-${color}`) {
              elements[i].style.opacity = 1;
            } else {
              elements[i].style.opacity = 0.15;
            }
          }
        };

        return (
          <Box direction="row" width="100%">
            <ActionButton plain onClick={() => setColour('none')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-none`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#777"
                style={
                  !['red', 'green', 'yellow'].includes(datum.flag)
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('green')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-green`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#00FF00"
                style={
                  'green' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('yellow')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-yellow`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#FFA500"
                style={
                  'yellow' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('red')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-red`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#FF0000"
                style={
                  'red' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
          </Box>
        );
      },
    },
    {
      property: 'actions',
      header: <Text>Actions</Text>,
      render: datum => (
        <>
          <Box direction="row" width="100%">

            {props?.type !== 'smartplan' && activeOrg.aiTermsAccepted && (
              <ActionButton
                onClick={() => {
                  navigate(`/incident/${datum.userId}/ai/${datum.id}`);
                }}
                target="_self"
                plain
                children={
                  <Box pad="5px">
                    <FontAwesomeIcon icon={['fal', 'robot']} color="#ff8300" />
                  </Box>
                }
              />
            )}
          </Box>
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={resultColumns}
        data={props.results}
        primaryKey="id"
        step={2000}
        sort={sort}
        onSort={setSort}
      />
      {!props.results.length && <Text>There are no results to display.</Text>}
    </>
  );
};

export default AIIncidentToolsResults;
